// ====================================================
// Handles the videos inside of Video/Image section
(function VideoImage() {
  // Setup popup video
  $('.voi_button-video').magnificPopup({
    type: 'inline',
    midClick: true,
    mainClass: 'mfp-fade',
    removalDelay: 160,
    closeBtnInside: false,
    preloader: false,
    fixedContentPos: false,
    callbacks: {
      open: function() {
        const popupVideo = document.querySelector('.voi_video-popup-frame');
        popupVideo.src = popupVideo.dataset.src;
        popupVideo.oncanplay = () => popupVideo.play();
      }
    }
  });

  // Set clicking on overlay play the video if autoplay fails
  const overlay = document.querySelector('.voi_overlay');
  const video = document.querySelector('.voi_video-frame');

  overlay.addEventListener('click', () => {
    if (video.paused)
      video.play();
  });
})();

// ====================================================
// Handles showing the Slideshow section button animation when button is in view
(function SlideshowAnimation() {
  const btnSlideshow = document.querySelector('.btn--slideshow');

  function animate() {
     const rect = btnSlideshow.getBoundingClientRect();
     const width = window.innerWidth || document.documentElement.clientWidth;
     const height = window.innerHeight || document.documentElement.clientHeight;

     if (rect.top >= 0 && rect.left >= 0) {
        if (rect.right <= width && rect.bottom <= height) {
           btnSlideshow.classList.add('slide-in');
           return;
        }
     }

     requestAnimationFrame(animate);
  }

  requestAnimationFrame(animate);
})();
